<template>
  <div class="table-container">
    <el-table
      class="table-content"
      :class="{border:border}"
      :data="tableData.list"
      stripe
      style="width: 100%"
      :header-row-style="{color:'#333333'}"
      :cell-style="{padding:'6px 0'}"
      @selection-change="selectionChange"
      @row-contextmenu="openMenu">
      <el-table-column
        v-if="tableData.selection"
        type="selection"
        width="50">
      </el-table-column>
      <template v-for="(item, index) in tableData.props">
        <el-table-column
          v-if="item.type==='img'"
          :label="item.label"
          :key="index"
          :width="item.width||''">
          <template slot-scope="scope">
            <div class="headimg" @click="callback(scope.row, index)">
              <img :src="scope.row[item.prop] || $store.state.default_img_url">
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.type==='normal_img'"
          :label="item.label"
          :key="index"
          :width="item.width||''">
          <template slot-scope="scope">
            <div class="normal-img" @click="callback(scope.row, index)">
              <img :src="scope.row[item.prop] || $store.state.default_img_url" v-img-frame>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.type==='time'"
          :label="item.label"
          :key="index"
          :width="item.width||''">
          <template slot-scope="scope">
            <p
              v-if="scope.row[item.prop]"
              class="time"
              @click="callback(scope.row, index)"
              :style="item.style">
                {{scope.row[item.prop]}}
                <span>&nbsp;&nbsp;({{getDay(scope.row[item.prop])}})</span>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="item.type==='time_day'"
          :label="item.label"
          :key="index"
          :width="item.width||''">
          <template slot-scope="scope">
            <span
              v-if="scope.row[item.prop]"
              class="time"
              @click="callback(scope.row, index)"
              :style="item.style">{{getDay(scope.row[item.prop])}}
            </span>
            <!-- <el-tooltip placement="top">
              <div slot="content">{{scope.row[item.prop]}}</div>
              <i class="gray el-icon-info"></i>
            </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :label="item.label"
          :key="index"
          :width="item.width||''">
          <template slot-scope="scope">
            <p @click="callback(scope.row, index)" :style="item.style" v-if="item.change">
              {{item.change(scope.row)}}
            </p>
            <p @click="callback(scope.row, index)" :style="item.style" v-else>
              <span v-if="item.prefix">{{item.prefix}}</span>
              {{scope.row[item.prop]}}
              <span v-if="item.postfix">{{item.postfix}}</span>
            </p>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      class="pager"
      background
      :page-size="size"
      layout="total, prev, pager, next, jumper"
      @current-change="currentPageChange"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
import getDay from '@/utils/getDay'
export default {
  name: 'TableComponent',
  props: {
    tableData: {
      type: Object
    },
    page: {
      type: Number
    },
    total: {
      type: Number
    },
    size: {
      type: Number
    },
    contextmenu: {
      type: [Object]
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    currentPageChange (e) {
      this.$emit('current-change', e)
    },
    selectionChange (e) {
      this.$emit('selection-change', e)
    },
    getDay (date) {
      return getDay(date)
    },
    openMenu (row, e) {
      if (this.contextmenu) {
        this.contextmenu.data = row
        this.$contextmenu.openMenu(this.contextmenu, e)
      }
    },
    callback (item, index) {
      this.tableData.props[index].clicked && this.tableData.props[index].clicked(item)
    }
  }
}
</script>
<style lang="less" scoped>
.table-container {
  margin-top: 10px;
}
.table-content {
  cursor: default;
}
.border {
  border: 1px solid #EBEEF5;
  border-bottom: none;
}
.headimg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #dddddd;
}
.headimg img {
  width: 100%;
  height: 100%;
}
.normal-img {
  height: 50px;
  img {
    height: 100%;
    width: auto;
  }
}
.pager {
  margin-top: 10px;
}
.time span{
  color: #999999;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Table/index.vue